// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3twiM","footer":"styles_footer__2Bm-0","passCodeTooltip":"styles_passCodeTooltip__2p6PV"};